<template>
    <div id="share">
        <transition-group name="fade">
            <template>
                <img :key="'dom1'" class="cup" src="../assets/answer-share/cup.png" alt="">
                <img :key="'dom11'" class="cup-child" src="../assets/answer-share/cup-child.png" alt="">
                <p v-if="!tmp_data.prize" :key="'dom2'" class="part2">{{$t('shareComm')}}</p>
                <div v-else class="show_prize" :key="'dom41'">
                    <p class="text">{{$t('shareBouns')}}</p>
                    <p class="number">$<span>{{tmp_data.prize}}</span></p>
                </div>
                <div :key="'dom3'" class="part3">
                    <span>{{$t('download')}}</span><img src="../assets/answer-share/AFlogo.png" alt="">
                </div>
                <p :key="'dom4'" class="part4">{{$t('share')}}</p>
                <div :key="'dom5'" class="code-box">
                    <p>{{tmp_data.code}}</p>
                    <div class="ok_btn" v-clipboard:copy="tmp_data.code" v-clipboard:success="copySuccess"
                         v-clipboard:error="copyError">
                        <img src="../assets/answer-share/copy.png" alt="" class="code-sure">{{$t('copy')}}
                    </div>
                </div>
                <div :key="'dom6'" class="download" @click="download">{{$t('download')}}<img
                    src="../assets/answer-share/download.png" alt=""></div>
            </template>
        </transition-group>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueClipboard from 'vue-clipboard2';

    Vue.use(VueClipboard);
    export default {
        data () {
            return {
                tmp_data: {
                    code: this.$route.query.code,
                    prize: this.$route.query.prize
                }
            };
        },
        mounted () {
            document.title = 'Super Football Hero';
        },
        methods: {
            copySuccess () {
                this.$toast(this.$t('copied'));
            },
            copyError () {
                this.$toast(this.$t('copyFailed'));
            },
            download () { // 下载
                location.href = 'https://go.onelink.me/1751978436?pid=PM2.2';
            }
        }
    };
</script>

<style lang="less">
    body, html, #app {
        height: 100%;
        overflow: hidden;
    }

    #share {
        position: relative;
        margin: 0;
        padding-top: 1px;
        font-family: 'sans-serif', 'PingFang SC', 'Microsoft YaHei', '微软雅黑', 'Helvetica', 'STHeiti', 'WenQuanYi Micro Hei', 'SimSun', 'sans-serif';
        color: #333;
        // background: #611ca9;
        // background: -webkit-linear-gradient(top,#5d2eb8,#6316a4);
        // background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#993a6b), color-stop(100%,#5d2eb8));
        background: url("../assets/answer-share/share_bg.jpg") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 100%;
        // min-height: 25rem;
        text-align: center;
        .text1 {
            height: 100px;
        }
    }

    p {
        margin: 0;
    }

    .cup {
        height: 8.25rem;
        width: auto;
        margin: 57px auto 0;
    }

    .cup-child {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }

    .part2 {
        width: 16.25rem;
        margin: 0 auto;
        font-size: 1.25rem;
        font-weight: 800;
        line-height: 1.56rem;
        color: #ffef39;
        margin-top: 1.03rem;
    }

    .show_prize {
        margin-top: 1.03rem;
        color: #ffef39;
        font-size: 1.06rem;
        line-height: 2.06rem;
        .number {
            font-size: 2.25rem;
            span {
                white-space: 2px;
                font-family: 'boldNumber';
                letter-spacing: 2px;
            }
        }
    }

    .part3 {
        margin-top: 2.28rem;
        color: #fff;
        line-height: 1.25rem;
        margin-bottom: 0.875rem;
        font-size: 0.875rem;
        > * {
            display: inline-block;
            vertical-align: middle;
        }
        img {
            height: 1.25rem;
            width: auto;
            margin-left: .31rem;
        }
    }

    .part4 {
        color: #fff;
        line-height: 1.25rem;
        font-size: 0.875rem;
        padding: 0 1.875rem;
    }

    .code-box {
        margin-top: 1.5rem;
        color: #fff;
        position: relative;
        > * {
            height: 2.812rem;
            line-height: 2.812rem;
            display: inline-block;
            font-size: 0;
            margin: 0;
        }
        p {
            margin: auto;
            width: 80%;
            padding: 0;
            // margin-left: 10%;
            border: 1px solid rgba(250, 250, 250, .5);
            border-radius: 2.812rem;
            font-size: 15px;
            z-index: 100;
            background: rgba(0, 0, 0, 0.3);
            outline: none;
            font-weight: 800;
            font-size: 1.25rem;
            letter-spacing: 2px;
            text-indent: 1.5em;
            color: #fff;
            box-sizing: border-box;
            text-align: left;
        }
        ::-webkit-input-placeholder { /* WebKit browsers */
            color: #999;
        }
        :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
            color: #999;
        }
        ::-moz-placeholder { /* Mozilla Firefox 19+ */
            color: #999;
        }
        .ok_btn {
            position: absolute;
            width: 6.41rem;
            color: #fff;
            margin-left: -6.875rem;
            font-size: .937rem;
            .code-sure {
                height: 1.25rem;
                width: auto;
                display: inline-block;
                vertical-align: text-bottom;
                padding-left: .625rem;
                margin-right: .31rem;
                border-left: 1px solid rgba(250, 250, 250, .3);
            }
        }
        .share-text {
            width: 100%;
            text-align: center;
        }
    }

    .download {
        // position: fixed;
        // bottom: 80px;
        // left: 0;
        // right: 0;
        margin: auto;
        margin-top: 1.875rem;
        color: #fff;
        background-color: #16ac3a;
        border-radius: 1.56rem;
        width: 14.973rem;
        height: 3.125rem;
        line-height: 3.125rem;
        font-size: 1.25rem;
        img {
            height: 1.187rem;
            width: auto;
            vertical-align: middle;
            margin-left: .31rem;
        }
    }
</style>



// WEBPACK FOOTER //
// AppAnswerShare.vue?9371c4ce